// components/Chat/ZenoOptions.jsx
import React, { useState } from 'react';

/**
 * Renderiza un bloque `options` de Zeno (tool ask_user_question) como una
 * pregunta seguida de botones seleccionables. Al elegir uno, ese texto se
 * envía como el siguiente mensaje del usuario (onSelect) — la elección del
 * usuario es simplemente su próximo turno, no hay endpoint especial.
 *
 * Una vez elegida una opción, los botones se deshabilitan y se marca la
 * elegida (solo dentro de la sesión; al recargar vuelven a estar activos
 * porque el backend no persiste cuál se eligió).
 */
export const ZenoOptions = ({ question, options, onSelect, disabled = false }) => {
  const [chosen, setChosen] = useState(null);
  const list = Array.isArray(options) ? options.filter((o) => typeof o === 'string' && o.trim()) : [];

  if (list.length === 0) return null;

  const locked = disabled || chosen !== null;

  const handleClick = (option) => {
    if (locked) return;
    setChosen(option);
    onSelect?.(option);
  };

  return (
    <div className="rounded-2xl border border-white/[0.12] bg-[#212129] px-5 py-4 shadow-[0_2px_10px_rgba(0,0,0,0.25)]">
      {question && (
        <p className="mb-3 text-gray-100 whitespace-pre-wrap leading-relaxed">{question}</p>
      )}
      <div className="flex flex-col gap-2">
        {list.map((option, idx) => {
          const isChosen = chosen === option;
          return (
            <button
              key={`${idx}-${option}`}
              type="button"
              onClick={() => handleClick(option)}
              disabled={locked}
              aria-pressed={isChosen}
              className={[
                'w-full rounded-xl border px-4 py-2.5 text-left text-sm transition-colors',
                isChosen
                  ? 'border-transparent bg-gradient-to-br from-[#7b3ff2] to-[#6321c4] text-white'
                  : locked
                    ? 'border-white/10 bg-white/[0.03] text-gray-500'
                    : 'border-white/15 bg-white/[0.04] text-gray-100 hover:border-[#7b3ff2]/60 hover:bg-[#7b3ff2]/10',
                locked ? 'cursor-default' : 'cursor-pointer',
              ].join(' ')}
            >
              {option}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ZenoOptions;
